import * as React from 'react';

import { getParkingTypes } from './helpers';
import { EParkingType, FOfferType, NonEmptyArray } from '../../../../../JsonQuery';
import { CheckboxButtonGroupUnselectable } from '../../CheckboxButtonGroupUnselectable';
import { Filter } from '../common/Filter';

interface IParkingProps {
  offerType: FOfferType;
  value: NonEmptyArray<EParkingType> | null;
  isRedesign: boolean;
  onChange(value: NonEmptyArray<EParkingType> | null): void;
}

export const Parking: React.FC<IParkingProps> = ({ offerType, value, onChange, isRedesign }) => {
  const parkingTypes = getParkingTypes(offerType, isRedesign);

  return (
    <Filter id="advancedFilter_parking" label="Парковка">
      <CheckboxButtonGroupUnselectable options={parkingTypes} value={value} onChange={onChange} />
    </Filter>
  );
};
